import { useMemo } from 'react'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  let {
    appointmentBooking: appointment_booking,
    patientId: patient_id,
    locationId: location_id,
  } = props

  return useMemo(
    () => ({
      ...data,
      appointment_booking,
      patient_id,
      location_id,
    }),
    [data, appointment_booking, patient_id, location_id]
  )
}
